export default __webpack_public_path__ + "media/images/mailer/icon_done-71951bea796c07c7bb83104be83e84fe.png";